import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

interface mainWordContainerProps {
  title: string;
  subTitleOne: string;
  subTitleTwo: string;
  onClick?: () => void;
}

const MainWordContainer: React.FC<mainWordContainerProps> = ({
  title,
  subTitleOne,
  subTitleTwo,
  onClick,
}) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          marginBottom: { xs: "10px", sm: "0px" },
          padding: { xs: "10px", sm: "0px" },
        }}
      >
        <Typography
          sx={{
            color: "#333333",
            fontWeight: 900,
            fontFamily: "Avenir",
            letterSpacing: "0px",
            opacity: 1,
            fontSize: {
              xs: "22px",
              sm: "24px",
              md: "34px",
              xl: "40px",
            },
            lineHeight: {
              xs: "30px",
              sm: "30px",
              md: "45px",
              xl: "50px",
            },
            paddingBottom: "11px",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            opacity: 1,
            fontSize: {
              xs: "16px",
              sm: "16px",
              md: "18px",
              xl: "26px",
            },
            lineHeight: {
              xs: "24px",
              sm: "28px",
              md: "28px",
              xl: "40px",
            },
            color: "#333333",
            fontFamily: "Avenir",
            letterSpacing: "0px",
          }}
        >
          {subTitleOne}
        </Typography>
        <Typography
          sx={{
            opacity: 1,
            fontSize: {
              xs: "16px",
              sm: "16px",
              md: "18px",
              xl: "26px",
            },
            lineHeight: {
              xs: "24px",
              sm: "28px",
              md: "28px",
              xl: "40px",
            },
            color: "#333333",
            fontFamily: "Avenir",
            letterSpacing: "0px",
          }}
        >
          {subTitleTwo}
        </Typography>
        {onClick && (
          <Button
            sx={{
              fontSize: {
                xs: "8px",
                sm: "10px",
                md: "14px",
                xl: "20px",
              },
              lineHeight: {
                xs: "8px",
                sm: "10px",
                md: "9px",
                xl: "12px",
              },
              color: "#ffffff",
              fontWeight: "900",
              fontFamily: "Avenir",
              textTransform: "unset",
              padding: "18px",
              backgroundColor: "#2685F8",
              borderRadius: "4px",
              marginTop: "15px",
              display: { xs: "none", sm: "set" },
              "&:hover": {
                backgroundColor: "#2685F8",
              },
            }}
            onClick={onClick}
          >
            Create My Profile
          </Button>
        )}
      </Box>
    </React.Fragment>
  );
};

export default MainWordContainer;
